import * as ko from "knockout";
import Pickr from '@simonwep/pickr';
import '@simonwep/pickr/dist/themes/nano.min.css';
import template from "./../templates/bao-color-palette.html";
var vm = function (params) {
    var self = this;

    if (params) {
        const pickr = Pickr.create({
            el: '.color-picker',
            theme: 'nano',
            appClass: 'custom-class',

            swatches: [
                'rgba(0, 0, 0, 1)',
                'rgba(223, 240, 216, 1)',
                'rgba(252, 248, 227, 1)',
                'rgba(242, 222, 222, 1)',
                'rgba(217, 237, 247, 1)'
            ],

            components: {

                // Main components
                preview: true,
                opacity: false,
                hue: true,

                // Input / output Options
                interaction: {
                    input: true
                }
            }
        });

        pickr.on('init', (color, instance) => {
            pickr.setColor(params.value());
            pickr.applyColor(true);
        });

        pickr.on('change', (color, instance) => {
            pickr.setColor(color.toHEXA().toString());
            pickr.applyColor(true);
            params.value(color.toHEXA().toString());
        });
    }
};

export default {
    viewModel: vm,
    template: template
};